<i18n>
{
	"en": {
		"title": "Changelog",
		"noChanges": "There have been no changes to this trip.",
		"close": "Close",
		"date": "Date",
		"user": "User",
		"trip": "Trip",
		"newValue": "New Value",
		"oldValue": "Old Value",
		"changeLocation": "Change Location",
		"removedLeg": "Deleted Leg",
		"newTrip": "Created",
		"newLeg": "Created",
		"showDetails": "Show Details",
		"field": "Field",
		"includeLegs": "Include Leg Changelogs",
		"leg": "Leg {n}",
		"ata": "ATA",
		"ata.date": "ATA",
		"atd": "ATD",
		"atd.date": "ATD",
		"cargoCarrier": "Cargo Carrier",
		"cargoCarrier.description": "Cargo Carrier - Description",
		"cargoCarrier.driver": "Cargo Carrier - Driver",
		"cargoCarrier.driver.email": "Cargo Carrier - Driver Email",
		"cargoCarrier.driver.name": "Cargo Carrier - Driver Name",
		"cargoCarrier.driver.phoneNumber": "Cargo Carrier - Driver Phone Number",
		"cargoCarrier.registrationNumber": "Cargo Carrier - Registration Number",
		"cargoCarrier.truckType": "Cargo Carrier - Truck Type",
		"cargoCarrier.truckType.code": "Cargo Carrier - Truck Type",
		"cargoCarrier.vendor": "Cargo Carrier - Owner",
		"cargoCarrier.vendor.countryCode": "Cargo Carrier - Owner Country Code",
		"cargoCarrier.vendor.name": "Cargo Carrier - Owner Name",
		"cargoCarrier.vendor.orgNo": "Cargo Carrier - Owner Org No.",
		"cargoCarrier.vendor.postalCode": "Cargo Carrier - Owner Postal Code",
		"cargoCarrier.vendor.postalPlace": "Cargo Carrier - Owner Postal Place",
		"cargoCarrier.vendor.street": "Cargo Carrier - Owner Street",
		"cargoCarrier.vendor.type": "Cargo Carrier - Owner Type",
		"cargoCarrier.vendor.vendorNumber": "Cargo Carrier - Owner Number",
		"clerk": "Clerk",
		"clerk.email": "Clerk Email",
		"clerk.name": "Clerk Name",
		"driver": "Driver",
		"driver.email": "Driver - Email",
		"driver.name": "Driver - Name",
		"driver.phoneNumber": "Driver - Phone Number",
		"endOdometer": "End Odometer",
		"eta": "ETA",
		"eta.date": "ETA",
		"etd": "ETD",
		"etd.date": "ETD",
		"events": "Events",
		"fromAddress": "From Address",
		"fromAddress.contactEmail": "From Address - Email",
		"fromAddress.contactName": "From Address - Contact Name",
		"fromAddress.contactPhone": "From Address - Phone Number",
		"fromAddress.country": "From Address - Country",
		"fromAddress.countryCode": "From Address - Country Code",
		"fromAddress.customerNumber": "From Address - Customer Number",
		"fromAddress.customsCreditNumber": "From Address - Customs Credit Number",
		"fromAddress.eori": "From Address - EORI",
		"fromAddress.exporterNumber": "From Address - Exporter Number",
		"fromAddress.gs1LocationNumber": "From Address - GS1 Locno.",
		"fromAddress.marks": "From Address - Marks",
		"fromAddress.name": "From Address - Name",
		"fromAddress.organizationNumber": "From Address - Organization Number",
		"fromAddress.postalCode": "From Address - Postal Code",
		"fromAddress.postalPlace": "From Address - Postal Place",
		"fromAddress.street": "From Address - Street",
		"fromAddress.vat": "From Address - MVA",
		"fromAddress.vendorNumber": "From Address - Vendor Number",
		"fromAddress.voec": "From Address - VOEC",
		"fromAddress.website": "From Address - Website",
		"fromAddressReference": "From Address Ref",
		"grossWeight": "Gr. Weight",
		"loadingMeters": "Loading Meters",
		"needAccept": "Need Accept",
		"packageEvents": "Package Events",
		"startOdometer": "Start Odometer",
		"status": "Status",
		"toAddress": "To Address",
		"toAddress.contactEmail": "To Address - Email",
		"toAddress.contactName": "To Address - Contact Name",
		"toAddress.contactPhone": "To Address - Phone Number",
		"toAddress.country": "To Address - Country",
		"toAddress.countryCode": "To Address - Country Code",
		"toAddress.customerNumber": "To Address - Customer Number",
		"toAddress.customsCreditNumber": "To Address - Customs Credit Number",
		"toAddress.eori": "To Address - EORI",
		"toAddress.exporterNumber": "To Address - Exporter Number",
		"toAddress.gs1LocationNumber": "To Address - GS1 Locno.",
		"toAddress.marks": "To Address - Marks",
		"toAddress.name": "To Address - Name",
		"toAddress.organizationNumber": "To Address - Organization Number",
		"toAddress.postalCode": "To Address - Postal Code",
		"toAddress.postalPlace": "To Address - Postal Place",
		"toAddress.street": "To Address - Street",
		"toAddress.vat": "To Address - MVA",
		"toAddress.vendorNumber": "To Address - Vendor Number",
		"toAddress.voec": "To Address - VOEC",
		"toAddress.website": "To Address - Website",
		"vendor": "Owner",
		"vendor.countryCode": "Owner - Country Code",
		"vendor.name": "Owner - Name",
		"vendor.orgNo": "Owner - Organization Number",
		"vendor.postalCode": "Owner - Postal Code",
		"vendor.postalPlace": "Owner - Postal Place",
		"vendor.street": "Owner - Street",
		"vendor.vendorNumber": "Owner - Vendor Number",
		"tripNumber": "Trip Number",
		"type": "Trip Type",
		"type.description": "Trip Type - Description",
		"type.internalCode": "Trip Type - Internal Code",
		"volume": "Volume",
		"viaLocations": "Via Locations",
		"viaLocations.viaNumber": "Via Location Order",
		"edi.ediSendingDate": "EDI Sending Date",
		"edi.ediSendingDate.date": "EDI Sending Date",
		"edi.ediSentDate": "EDI Sent Date",
		"edi.ediSentDate.date": "EDI Sent Date",
		"registeredDate": "Registered Date",
		"aborted": "Cancelled",
		"notCleared": "Not cleared",
		"settlement": "Ready for settlement",
		"invoice": "Ready for invoice",
		"unknown": "Unknown",
		"draft": "Draft",
		"received": "Received",
		"rejected": "Rejected",
		"ready": "Ready",
		"planned": "Planned",
		"unsuccessful": "Unsuccessful",
		"requested": "Requested",
		"accepted": "Accepted",
		"selectStatus": "Select status",
		"readyForPickup": "Ready for pickup",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"incomplete": "Incomplete",
		"notSettled": "Not settled",
		"settled": "Settled",
		"invoiced": "Invoiced",
		"recorded": "Recorded",
		"collected": "Collected",
		"delivered": "Delivered",
		"inbound": "Inbound",
		"outbound": "Outbound",
		"appSend": "Sent to Confirm",
		"info": "Information",
		"ediInstructionReceived": "Inbound EDI",
		"ediInstructionSent": "Outbound EDI",
		"ediTrackAndTraceSent" : "Outbound EDI"
	},
	"no": {
		"title": "Endringer",
		"noChanges": "Ingen endringer registrert på denne turen.",
		"close": "Close",
		"date": "Dato",
		"user": "Bruker",
		"trip": "Hovedtur",
		"newValue": "Ny verdi",
		"oldValue": "Gammel verdi",
		"changeLocation": "Endre",
		"removedLeg": "Slettet Leg",
		"newTrip": "Laget",
		"newLeg": "Laget",
		"showDetails": "Vis detaljer",
		"field": "Field",
		"includeLegs": "Inkluder legs endringer",
		"leg": "Leg {n}",
		"ata": "ATA",
		"ata.date": "ATA",
		"atd": "ATD",
		"atd.date": "ATD",
		"cargoCarrier": "Lastebærer",
		"cargoCarrier.description": "Lastebærer - Beskrivelse",
		"cargoCarrier.driver": "Lastebærer - Sjåfør",
		"cargoCarrier.driver.email": "Lastebærer - Sjåfør E-post",
		"cargoCarrier.driver.name": "Lastebærer - Sjåfør Navn",
		"cargoCarrier.driver.phoneNumber": "Lastebærer - Sjåfør Telefon",
		"cargoCarrier.registrationNumber": "Lastebærer - Reg.nr.",
		"cargoCarrier.truckType": "Lastebærer - Lastebiltype",
		"cargoCarrier.truckType.code": "Lastebærer - Lastebiltype",
		"cargoCarrier.vendor": "Lastebærer - Eier",
		"cargoCarrier.vendor.countryCode": "Lastebærer - Eier Landkode",
		"cargoCarrier.vendor.name": "Lastebærer - Eier Navn",
		"cargoCarrier.vendor.orgNo": "Lastebærer - Eier Org No.",
		"cargoCarrier.vendor.postalCode": "Lastebærer - Eier Postnummer",
		"cargoCarrier.vendor.postalPlace": "Lastebærer - Eier Poststed",
		"cargoCarrier.vendor.street": "Lastebærer - Eier Gate",
		"cargoCarrier.vendor.type": "Lastebærer - Eier Type",
		"cargoCarrier.vendor.vendorNumber": "Lastebærer - Eier Nummer",
		"clerk": "Ansvarlig",
		"clerk.email": "Ansvarlig - E-post",
		"clerk.name": "Ansvarlig - Navn",
		"driver": "Sjåfør",
		"driver.email": "Sjåfør - E-post",
		"driver.name": "Sjåfør - Navn",
		"driver.phoneNumber": "Sjåfør - Telefon",
		"endOdometer": "Endelig kilometerteller",
		"eta": "ETA",
		"eta.date": "ETA",
		"etd": "ETD",
		"etd.date": "ETD",
		"events": "Hendelser",
		"frommAddress": "Fra Adresse",
		"frommAddress.contactEmail": "Fra Adresse - E-post",
		"frommAddress.contactName": "Fra Adresse - Contact navn",
		"frommAddress.contactPhone": "Fra Adresse - Telefon",
		"frommAddress.country": "Fra Adresse - Land",
		"frommAddress.countryCode": "Fra Adresse - Landkode",
		"frommAddress.customerNumber": "Fra Adresse - Kunde",
		"frommAddress.customsCreditNumber": "Fra Adresse - Tollkredittnummber",
		"frommAddress.eori": "Fra Adresse - EORI",
		"frommAddress.exporterNumber": "Fra Adresse - Eksportør nummer",
		"frommAddress.gs1LocationNumber": "Fra Adresse - GS1 Locno.",
		"frommAddress.marks": "Fra Adresse - Merknader",
		"frommAddress.name": "Fra Adresse - Navn",
		"frommAddress.organizationNumber": "Fra Adresse - Foretaksnummer",
		"frommAddress.postalCode": "Fra Adresse - Postnummer",
		"frommAddress.postalPlace": "Fra Adresse - Poststed",
		"frommAddress.street": "Fra Adresse - Gate",
		"frommAddress.vat": "Fra Adresse - MVA",
		"frommAddress.vendorNumber": "Fra Adresse - Leverandør",
		"frommAddress.voec": "Fra Adresse - VOEC",
		"frommAddress.website": "Fra Adresse - Internett",
		"frommAddressReference": "Fra Adresse Ref",
		"grossWeight": "Br. vekt",
		"loadingMeters": "Lastemeter",
		"needAccept": "Trenger godta",
		"packageEvents": "Pakkehendelser",
		"startOdometer": "Starter kilometerteller",
		"status": "Status",
		"toAddress": "Til Adresse",
		"toAddress.contactEmail": "Til Adresse - E-post",
		"toAddress.contactName": "Til Adresse - Contact navn",
		"toAddress.contactPhone": "Til Adresse - Telefon",
		"toAddress.country": "Til Adresse - Land",
		"toAddress.countryCode": "Til Adresse - Landkode",
		"toAddress.customerNumber": "Til Adresse - Kunde",
		"toAddress.customsCreditNumber": "Til Adresse - Tollkredittnummber",
		"toAddress.eori": "Til Adresse - EORI",
		"toAddress.exporterNumber": "Til Adresse - Eksportør nummer",
		"toAddress.gs1LocationNumber": "Til Adresse - GS1 Locno.",
		"toAddress.marks": "Til Adresse - Merknader",
		"toAddress.name": "Til Adresse - Navn",
		"toAddress.organizationNumber": "Til Adresse - Foretaksnummer",
		"toAddress.postalCode": "Til Adresse - Postnummer",
		"toAddress.postalPlace": "Til Adresse - Poststed",
		"toAddress.street": "Til Adresse - Gate",
		"toAddress.vat": "Til Adresse - MVA",
		"toAddress.vendorNumber": "Til Adresse - Leverandør",
		"toAddress.voec": "Til Adresse - VOEC",
		"toAddress.website": "Til Adresse - Internett",
		"vendor": "Eier",
		"vendor.countryCode": "Eier - Landkode",
		"vendor.name": "Eier - Name",
		"vendor.orgNo": "Eier - Org.Nr.",
		"vendor.postalCode": "Eier - Postnummer",
		"vendor.postalPlace": "Eier - Poststed",
		"vendor.street": "Eier - Gate",
		"vendor.vendorNumber": "Eier - Leverandørnummer.",
		"tripNumber": "Turnummer",
		"type": "Tur Type",
		"type.description": "Tur Type - Beskrivelse",
		"type.internalCode": "Tur Type - Intern kode",
		"volume": "Volum",
		"viaLocations": "Via Sted",
		"viaLocations.viaNumber": "Via Sted Rekkefølge",
		"edi.ediSendingDate": "EDI Sendingsdato",
		"edi.ediSendingDate.date": "EDI Sendingsdato",
		"edi.ediSentDate": "EDI Sendt Dato",
		"edi.ediSentDate.date": "EDI Sendt Dato",
		"registeredDate": "Registrert dato",
		"aborted": "Annullert",
		"notCleared": "Ikke klarert",
		"settlement": "Klar for avregning",
		"invoice": "Klar for fakturering",
		"unknown": "Ukjent",
		"cancelled": "Annullert",
		"draft": "Kladd",
		"received": "Mottatt",
		"rejected": "Avslått",
		"ready": "Klar",
		"planned": "Planlagt",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Akseptert",
		"selectStatus": "Velg status",
		"readyForPickup": "Klar for henting",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"incomplete": "Ufullstendig",
		"notSettled": "Ikke klarert",
		"settled": "Klarert",
		"invoiced": "Oppgjort",
		"recorded": "Bokført",
		"collected": "Hentet",
		"delivered": "Levert",
		"inbound": "Inngående",
		"outbound": "Utgående",
		"appSend": "Sendt til Confirm",
		"info": "Informasjon",
		"ediInstructionReceived": "Inngående EDI",
		"ediInstructionSent": "Utgående EDI",
		"ediTrackAndTraceSent" : "Utgående EDI"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:title="$t('title')"
		:hasConfirm="false"
		:cancelLabel="$t('close')"
		icon="history"
		iconType="bp"
		iconColor="blue"
		width="1600px"
		@close="$emit('close')"
	>
		<div slot="title-after" class="include-suborders-checkbox">
			<t-checkbox
				:checked="includeLegs"
				:label="$t('includeLegs')"
				@change="toggleIncludeLegs"
			/>
		</div>
		<t-horizontal-panel
			style="height: 690px; width: 1566px;"
			:showRightPanel="showDetailsVisible"
		>
			<template>
				<t-grid
					v-if="changelog && changelog.length > 0"
					:items="filteredChangelog"
					:columnDefinitions="columnDefinitions"
					:defaultColumnDefinition="defaultColumnDefinition"
					:rowHeight="40"
					:sort="sort"
					style="height: 690px; width: 1566px;"
				>
					<template v-slot:clerk="{ displayValue }">
						<div v-if="displayValue" style="height: 16px;">
							<template v-if="displayValue.name">
								{{displayValue.name}}
							</template>
							<template v-else-if="displayValue.email">
								{{displayValue.email}}
							</template>
							<template v-else-if="displayValue.phoneNumber">
								{{displayValue.phoneNumber}}
							</template>
						</div>
						<div v-if="displayValue && displayValue.name" class="grid-cell-sub-line">
							<template v-if="displayValue.email">
								{{displayValue.email}}
							</template>
							<template v-else-if="displayValue.phoneNumber">
								{{displayValue.phoneNumber}}
							</template>
						</div>
					</template>
					<template v-slot:oldValue="{ item, displayValue }">
						<div v-if="isObject(displayValue)" class="grid-cell-details">
							<DetailsCell
								v-if="isAddressField(item.field)"
								:mainValue="displayValue.name"
								:subValue="`${displayValue.street}, ${displayValue.postalCode} ${displayValue.postalPlace}`"
							/>
							<DetailsCell
								v-else-if="item.field === 'cargoCarrier'"
								:mainValue="displayValue.description"
								:subValue="displayValue.registrationNumber"
							/>
							<DetailsCell
								v-else-if="item.field === 'clerk'"
								:mainValue="displayValue.name"
								:subValue="displayValue.email"
							/>
							<DetailsCell
								v-else-if="item.field === 'driver'"
								:mainValue="displayValue.name"
								:subValue="displayValue.email"
							/>
							<DetailsCell
								v-else-if="item.field === 'events' || item.field === 'packageEvents'"
								:mainValue="$t(displayValue.type)"
								:subValue="getEventText(displayValue)"
							/>
							<DetailsCell
								v-else-if="item.field === 'vendor'"
								:mainValue="displayValue.name"
								:subValue="displayValue.vendorNumber"
							/>
							<DetailsCell
								v-else-if="item.field === 'type'"
								:mainValue="displayValue.description"
								:subValue="displayValue.internalCode"
							/>
							<DetailsCell
								v-else-if="item.field === 'viaLocations'"
								:mainValue="displayValue.address.name"
								:subValue="getStorageDate(displayValue.dateTimeObject.date)"
							/>
							<t-button
								v-if="allowDetailsButton(item.field)"
								appearance="primary"
								type="bp"
								@click="showDetails(item.field, item.op, item.oldValue)"
							>{{ $t('showDetails') }}</t-button>
						</div>
						<div v-else>
							{{ displayValue }}
						</div>
					</template>
					<template v-slot:value="{ item, displayValue }">
						<div v-if="isObject(displayValue)" class="grid-cell-details">
							<DetailsCell
								v-if="isAddressField(item.field)"
								:mainValue="displayValue.name"
								:subValue="`${displayValue.street}, ${displayValue.postalCode} ${displayValue.postalPlace}`"
							/>
							<DetailsCell
								v-else-if="item.field === 'cargoCarrier'"
								:mainValue="displayValue.description"
								:subValue="displayValue.registrationNumber"
							/>
							<DetailsCell
								v-else-if="item.field === 'clerk'"
								:mainValue="displayValue.name"
								:subValue="displayValue.email"
							/>
							<DetailsCell
								v-else-if="item.field === 'driver'"
								:mainValue="displayValue.name"
								:subValue="displayValue.email"
							/>
							<DetailsCell
								v-else-if="item.field === 'events' || item.field === 'packageEvents'"
								:mainValue="$t(displayValue.type)"
								:subValue="getEventText(displayValue)"
							/>
							<DetailsCell
								v-else-if="item.field === 'vendor'"
								:mainValue="displayValue.name"
								:subValue="displayValue.vendorNumber"
							/>
							<DetailsCell
								v-else-if="item.field === 'type'"
								:mainValue="displayValue.description"
								:subValue="displayValue.internalCode"
							/>
							<DetailsCell
								v-else-if="item.field === 'viaLocations'"
								:mainValue="displayValue.address.name"
								:subValue="getStorageDate(displayValue.dateTimeObject.date)"
							/>

							<t-button
								v-if="allowDetailsButton(item.field)"
								appearance="primary"
								type="bp"
								@click="showDetails(item.field, item.op, item.value)"
							>{{ $t('showDetails') }}</t-button>
						</div>
						<div v-else>
							{{ displayValue }}
						</div>
					</template>
				</t-grid>
				<t-no-content-panel
					v-else
					:text="$t('noChanges')"
					icon="history"
					iconType="bp"
					class="log-content"
					noBetweenGap
				/>
			</template>

			<template v-slot:right >
				<Address
					v-if="showDetailsVisible && isAddressField(detailsField)"
					:field="detailsField"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<CargoCarrier
					v-if="showDetailsVisible && detailsField === 'cargoCarrier'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<Clerk
					v-if="showDetailsVisible && detailsField === 'clerk'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<Event
					v-if="showDetailsVisible && (detailsField === 'events' || detailsField === 'packageEvents')"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<Vendor
					v-if="showDetailsVisible && detailsField === 'vendor'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
				<ViaLocation
					v-if="showDetailsVisible && detailsField === 'viaLocations'"
					:data="detailsObject"
					:op="detailsOp"
					@close="hideDetails"
				/>
			</template>
		</t-horizontal-panel>
	</t-dialog>
</template>

<script>
import Address from './tripChangelog/Address';
import CargoCarrier from './tripChangelog/CargoCarrier';
import Clerk from './tripChangelog/Clerk';
import Event from './tripChangelog/Event';
import Vendor from './tripChangelog/Vendor';
import ViaLocation from './tripChangelog/ViaLocation';
import DetailsCell from './tripChangelog/DetailsCell';
import { storageDateFormat, statuses } from '@/core';
import moment from 'moment';

export default {
	name: 'TripChangelog',
	components: {
		DetailsCell,
		Address,
		CargoCarrier,
		Clerk,
		Event,
		Vendor,
		ViaLocation,
	},
	props: {
		isShown: Boolean,
		changelog: Array,
		legs: Array
	},
	data() {
		return {
			defaultColumnDefinition: { resizable: false, },
			sort: [{ field: 'changeDate', direction: 'desc' }],
			includeLegs: false,
			showDetailsVisible: false,
			detailsObject: {},
			detailsField: '',
			detailsOp: '',
			detailsEnabled: [
				'fromAddress',
				'toAddress',
				'events',
				'packageEvents',
				'vendor',
				'cargoCarrier',
				'viaLocations'
			],
			addressFields: ['fromAddress','toAddress']
		};
	},
	computed: {
		columnDefinitions() {
			return [
				{
					field: 'changeDate',
					displayName: this.$t('date'),
					valueGetter: (item) => this.getDate(item.changeDate),
					width: 150,
				},
				{
					field: 'clerk',
					valueGetter: item => item.clerk,
					displayName: this.$t('user'),
					width: 200,
				},
				{
					field: 'type',
					displayName: this.$t('changeLocation'),
					valueGetter: (item) => item.type === 'leg' ? this.getLegLabel(item.legId) : this.$t(item.type),
					minWidth: 250,
					width: 250,
					resizable: true,
				},
				{
					field: 'field',
					displayName: this.$t('field'),
					valueGetter: (item) => this.$t(item.field),
					minWidth: 300,
					resizable: true,
				},
				{
					field: 'oldValue',
					displayName: this.$t('oldValue'),
					displayValueGetter: (item) => this.formatValue(item.field, item.oldValue),
					comparableValueGetter: (item) => this.getCompareValue(item.field, item.oldValue),
					minWidth: 300,
					resizable: true,
				},
				{
					field: 'value',
					displayName: this.$t('newValue'),
					displayValueGetter: (item) => this.formatValue(item.field, item.value),
					comparableValueGetter: (item) => this.getCompareValue(item.field, item.value),
					minWidth: 300,
					resizable: true,
				},
			];
		},
		filteredChangelog() {
			let showLegs = this.includeLegs;
			return this.changelog.filter(x => {
				let isTrip = x.type === 'trip';
				let isLeg = x.type === 'leg';
				if (x.admin) return false;
				if (x.op === 'remove' && x.oldValue === '') return false;
				return isTrip || (showLegs && isLeg);
			});
		}
	},
	mounted() {
		let includeLegs = localStorage.getItem('tripChangelogIncludeLegs');
		if (includeLegs === 'true')
			this.toggleIncludeLegs(true);
	},
	methods: {
		getLegLabel(id) {
			let index = this.legs.findIndex(x => x.id === id);
			if (index === -1) return this.$t('removedLeg');
			return this.$t('leg', { n: index+1 });
		},
		onClose() {
			this.showGrid = false;
			this.$emit('close');
		},
		isObject(item) {
			return typeof item === 'object' && item !== null;
		},
		getDate(date) {
			return moment(date).format('DD.MM.YYYY HH:mm');
		},
		getEventText(item) {
			return (this.$i18n.locale==='nb-NO' || this.$i18n.locale==='nn-NO' || this.$i18n.locale==='no')
				? (item.info || item.infoEn)
				: (item.infoEn || item.info);
		},
		formatValue(field, value) {
			if (!field || value === null || value === undefined) return value;
			if (field.includes('.date')) return this.getStorageDate(value);
			if (field === 'etd' || field === 'eta' || field === 'atd' || field === 'ata' || field === 'edi.ediSendingDate' || field === 'edi.ediSentDate' || field === 'registeredDate') {
				return this.getStorageDate(value.date);
			}
			if (field === 'edi' && value.ediSendingDate) {
				return this.getStorageDate(value.ediSendingDate.date);
			}
			if (field === 'edi' && value.ediSentDate) {
				return this.getStorageDate(value.ediSentDate.date);
			}
			if (field === 'status') {
				return this.$t(statuses.operational(value));
			}
			return value;
		},
		getCompareValue(field, value) {
			let compValue = this.formatValue(field, value);
			if (compValue === null || compValue === undefined) return value;
			
			if (this.isObject(compValue)) {
				if (this.isAddressField(field)) {
					return `${compValue.name} ${compValue.street} ${compValue.postalCode} ${compValue.postalPlace}`;
				}
				switch (field) {
				case 'cargoCarrier': return `${compValue.description} ${compValue.registrationNumber}`;
				case 'clerk': return `${compValue.name} ${compValue.email} ${compValue.phoneNumber}`;
				case 'driver': return `${compValue.name} ${compValue.email} ${compValue.phoneNumber}`;
				case 'events':
				case 'packageEvents':
					return `${this.$t(compValue.type)} ${this.getEventText(compValue)}`;
				case 'orderType': return compValue.name;
				case 'vendor': return `${compValue.name} ${compValue.vendorNumber}`;
				case 'type': return `${compValue.description} ${compValue.internalCode}`;
				case 'viaLocations': return `${compValue.address.name} ${this.getStorageDate(compValue.dateTimeObject.date)}`;
				default: return '';
				}
			}
			return compValue;
		},
		getStorageDate(date) {
			if (!date) return '';
			return moment(date, storageDateFormat).format('DD.MM.YYYY HH:mm');
		},
		showDetails(field, op, data) {
			this.showDetailsVisible = true;
			this.detailsField = field;
			this.detailsOp = op;
			this.detailsObject = data;
		},
		hideDetails() {
			this.showDetailsVisible = false;
			this.detailsField = '';
			this.detailsOp = '';
			this.detailsObject = {};
		},
		allowDetailsButton(field) {
			return this.detailsEnabled.includes(field);
		},
		isAddressField(field) {
			return this.addressFields.includes(field);
		},
		toggleIncludeLegs(value = true) {
			this.includeLegs = value;
			localStorage.setItem('tripChangelogIncludeLegs', value);
		}
	}
};
</script>

<style lang="scss" scoped>
.log {
	height: 100%;
	min-height: inherit;
}

.log-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	background: white;
}

/deep/ .horizontal-panel-content {
	overflow-x:auto;
}

.grid-cell-details {
	display: flex;
	justify-content: space-between;
}

.include-suborders-checkbox {
	padding-left: 20px;
}
</style>
